// Seconds as m:ss, the way a clip length is written on a thumbnail.
export default function formatDuration(seconds) {
  if (!seconds && seconds !== 0) {
    return '';
  }

  const rounded = Math.round(seconds);
  const minutes = Math.floor(rounded / 60);

  return `${minutes}:${(rounded % 60).toString().padStart(2, '0')}`;
}
